import React from "react"
import styled from "styled-components"

const LeftChevronWrapper = styled.div``

const LeftChevron = props => (
  <LeftChevronWrapper onClick={props.onClick} hoverColor={props.hoverColor}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="11"
      viewBox="0 0 7 11"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#96CDFF"
        d="M6 0L1 5.532 6 11"
      />
    </svg>
  </LeftChevronWrapper>
)

export { LeftChevron as default }



// WEBPACK FOOTER //
// ./assets/common/components/LeftChevron.js